"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PieceRegistry = void 0;
var pieceRegistry_1 = require("./piece/pieceRegistry");
Object.defineProperty(exports, "PieceRegistry", { enumerable: true, get: function () { return pieceRegistry_1.PieceRegistry; } });
